export default __webpack_public_path__ + "static/media/T_Yellow.435b9365.png";